/*
 * The entry point script that loads everything once.
 */

require('./bootstrap');

Vue.component('notification-toast', require('./components/NotificationToast').default);
Vue.component('blocked-users-table', require('./components/BlockedUsersTable').default);
Vue.component('user-rating', require('./components/UserRating').default);
Vue.component('bid-user-avaliation', require('./components/BidUserAvaliation').default);
Vue.component('attachment', require('./components/Attachment').default);
Vue.component('chat', require('./components/Chat').default);
Vue.component('bid-status', require('./components/BidStatus').default);
Vue.component('bid-payment', require('./components/BidPayment').default);
Vue.component('edit-bid', require('./components/EditBid').default);
Vue.component('edit-bid-admin', require('./components/EditBidAdmin').default);
Vue.component('create-bid', require('./components/CreateBid').default);
Vue.component('field-form', require('./components/FieldForm').default);
Vue.component('profile-form', require('./components/ProfileForm').default);
Vue.component('location-form', require('./components/LocationForm').default);
Vue.component('location-form-landing-page', require('./components/LocationFormLandingPage').default);
Vue.component('checkout-form-pagseguro', require('./components/CheckoutFormPagseguro').default);
Vue.component('checkout-form-vindi', require('./components/CheckoutFormVindi').default);
Vue.component('checkout-form-captacao-vindi', require('./components/CheckoutFormCaptacaoVindi').default);
Vue.component('password-form', require('./components/PasswordForm').default);
Vue.component('create-article', require('./components/CreateArticle').default);
Vue.component('create-page', require('./components/CreatePage').default);
Vue.component('settings-form', require('./components/SettingsForm').default);
Vue.component('credit-package-form', require('./components/CreditPackageForm').default);
Vue.component('credit-package-partnership-form', require('./components/CreditPackagePartnershipForm').default);
Vue.component('credit-package-recurrent-form', require('./components/CreditPackageRecurrentForm').default);
Vue.component('credit-package-recurrent-partnership-form', require('./components/CreditPackageRecurrentPartnershipForm').default);
Vue.component('users-convertion-chart', require('./components/UserConvertionChart').default);
Vue.component('rating-fields', require('./components/RatingFields').default);
Vue.component('rating-subscribe-chart', require('./components/RatingSubscribeChart').default);
Vue.component('rating-closebid-chart', require('./components/RatingCloseBidChart').default);
Vue.component('rating-createbid-chart', require('./components/RatingCreateBidChart').default);
Vue.component('rating-register-chart', require('./components/RatingRegisterChart').default);
Vue.component('search-users', require('./components/SearchUsers').default);
Vue.component('bids-table', require('./components/BidsTable').default);
Vue.component('states-for-fields', require('./components/StatesForFields').default);
Vue.component('fields-for-states', require('./components/FieldsForStates').default);
Vue.component('experts-in-fields', require('./components/ExpertsForFields').default);
Vue.component('experts-in-fields-detail', require('./components/ExpertsForFieldsDetail').default);
Vue.component('combo-fields', require('./components/ComboFields').default);
Vue.component('fields-table', require('./components/FieldsTable').default);
Vue.component('field-form-admin', require('./components/FieldFormAdmin').default);
Vue.component('publication-page', require('./components/PublicationPage').default);
Vue.component('publication-page-header', require('./components/HeaderPublicationPage').default);
Vue.component('partnership-table-admin', require('./components/PartnershipTableAdmin').default);
Vue.component('partnership-create-admin', require('./components/PartnershipCreateAdmin').default);
Vue.component('partnership-edit-admin', require('./components/PartnershipEditAdmin').default);
Vue.component('user-expert-edit-admin', require('./components/UserExpertEditAdmin').default);
Vue.component('demo-product-admin', require('./components/DemoProductAdmin').default);
Vue.component('publications-in-fields', require('./components/PublicationsForFields').default);

Vue.config.devtools = false;
Vue.config.debug = false;
Vue.config.silent = false;

const app = new Vue({
    el: '.myexpert'
});
